import { ThirdPartyFulfillmentBudgetChange } from "@redotech/redo-fulfillment-common/third-party-fulfillment-budget";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const saveThirdPartyFulfillmentBudget = unaryRpc({
  name: "saveThirdPartyFulfillmentBudget" as const,
  input: ThirdPartyFulfillmentBudgetChange,
  output: z.object({ workflowId: z.string() }),
});
